export default "__VITE_ASSET__BChla0Co__"